import { Navigate } from "react-router-dom";
import { useAuth } from "@itaas/core/auth/useAuth";
import { defaultPlatformPath, canAccessPlatformHub } from "@/navigation/platform-access";
import { routes } from "@/router/all_routes";

export function PlatformIndexRedirect() {
  const { user } = useAuth();
  if (!canAccessPlatformHub(user)) {
    return <Navigate to={routes.accessDenied} replace />;
  }
  return <Navigate to={defaultPlatformPath(user)} replace />;
}
